import { render } from "./LoadBalancing.vue?vue&type=template&id=4a5b7a6c&scoped=true"
import script from "./LoadBalancing.vue?vue&type=script&lang=js"
export * from "./LoadBalancing.vue?vue&type=script&lang=js"

import "./LoadBalancing.vue?vue&type=style&index=0&id=4a5b7a6c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5b7a6c"]])

export default __exports__